//#region src/version.ts
const VERSION = "2.12.0";
//#endregion
export { VERSION };

//# sourceMappingURL=version.js.map